// src/features/locker-assignments/components/forms/AssignmentDetailsSection.tsx
import React from 'react';
import { DateTimeInput, required } from 'react-admin';
import { Grid } from '@mui/material';
import { Schedule as ScheduleIcon } from '@mui/icons-material';
import { MyFormSection } from '@/components';

interface AssignmentDetailsSectionProps {
  // No props necesarios ya que DateTimeInput se maneja internamente con react-admin
}

export const AssignmentDetailsSection: React.FC<AssignmentDetailsSectionProps> = () => {
  return (
    <MyFormSection title="Assignment Details" icon={<ScheduleIcon />}>
      <Grid container spacing={2}>
        <Grid item xs={12} md={6} sx={{ display: 'flex' }}>
          <DateTimeInput
            source="startsAt"
            label="Start Date"
            validate={[required()]}
            fullWidth
          />
        </Grid>
        <Grid item xs={12} md={6} sx={{ display: 'flex' }}>
          <DateTimeInput
            source="expiresAt"
            label="End Date"
            validate={[required()]}
            fullWidth
          />
        </Grid>
      </Grid>
    </MyFormSection>
  );
};